import { TextInput, Select } from '@mantine/core';

import { OpenLinkOpenMethod } from '#/components/ui/messages/model';
import { useActionEditorFormContext } from '../../context';

import { makeKFunc } from '../utils';

const OPEN_LINK_OPEN_METHOD_OPTIONS: Array<{
  label: string;
  value: OpenLinkOpenMethod;
}> = [
  { value: 'in_app', label: 'in app' },
  { value: 'browser', label: 'browser' },
  { value: 'deep_link', label: 'deep link' },
];

export const OpenLinkFields = ({ keyPrefix }: { keyPrefix?: string }) => {
  const form = useActionEditorFormContext();

  const k = makeKFunc(keyPrefix);

  return (
    <>
      <Select
        label={`開啟方式`}
        withAsterisk
        data={OPEN_LINK_OPEN_METHOD_OPTIONS}
        key={form.key(k`attribute_schema.open_method`)}
        {...form.getInputProps(k`attribute_schema.open_method`)}
        allowDeselect={false}
      />
      <TextInput
        label="URL"
        withAsterisk
        key={form.key(k`attribute_schema.url`)}
        {...form.getInputProps(k`attribute_schema.url`)}
      />
    </>
  );
};
